import { writable } from 'svelte/store';
import { random_string } from "../../libraries/random_string"
import * as Ramda from "ramda"

function parse(n){
    return Number.parseFloat(Number.parseFloat(n).toFixed(2));
}

function storeCart() {
    const defaultValues = {
        items: {},
        has_discount: false,
        discounts: {year: 0, month: 0},
        subtotal: {year: 0, month: 0},
        total: {year: 0, month: 0},
    }
	const { subscribe, set, update } = writable(defaultValues);
    const Cart = {
        subscribe,
        restore: function(){
            update((data)=>{
                data = Ramda.clone(defaultValues);
                return data;
            })
        },
        updateSubtotals: function(prices){

            update((data)=>{
                data.subtotal.year = parse(data.subtotal.year + prices.year.current);
                data.subtotal.month = parse(data.subtotal.month + prices.month.current);
                return data;
            })

        },
        updateTotals: function(prices){
            update((data)=>{
                data.total.year = parse(data.total.year + prices.year);
                data.total.month = parse(data.total.month + prices.month);
                return data;
            })
        },
        updateDiscounts: function(discount, interval){

            update((data)=>{
                data.discounts[interval] = parse(data.discounts[interval] + discount);
                data.has_discount = true;
                return data;
            })
            
        },
        update: function(item, id){
            update((data)=>{
                data.items[id] = item;
                return data;
            })
        },
        remove: function(id){
            update((data)=>{
                try {
                    delete data.items[id];
                } catch (error) {
                    console.warn("No hay un elemento con esta ID. "+id)
                }
                
                return data;
            })
        }
    }
    return Cart;
}




class ItemCart
{
    constructor({prices, id, name, icon, discountPercent, interval, membership_type, plan}){
        let item = {};
        item.id = id ?? ("item-"+random_string(6));
        item.icon = icon ?? "plan-icon-startup";
        item.membership_type = membership_type ?? null;
        item.plan = plan ?? null;
        item.prices = prices,
        item.name = name ?? "-",
        item.interval = interval ?? "month",
        item.discount = discountPercent ?? 0;
        

        this.discountable = function(price, interval){
            price = parse(price)
            if(discountPercent <= 0){
                return null;
            }
            let discount = parse( ((discountPercent/100)*price) );
            
            StoreCart.updateDiscounts(discount, interval);

            return parse(price-discount);
        }

       
       

        if(discountPercent > 0){
            item.prices.month.with_discount = this.discountable(item.prices.month.current, "month");
            item.prices.year.with_discount = this.discountable(item.prices.year.current, "year");



            StoreCart.updateSubtotals(prices);
            StoreCart.updateTotals({
                year: item.prices.year.with_discount,
                month: item.prices.month.with_discount,
            });
            
            
        }else{

            StoreCart.updateSubtotals(prices);
            StoreCart.updateTotals({
                year: item.prices.year.current,
                month: item.prices.month.current,
            });

        }


        this.item = item;
    }    
    add(){
        StoreCart.update(this.item, this.item.id)
    }
    delete(){
        StoreCart.remove(item.id)
    }
}


/**
 * Parser code
 */
class CartParserAddons 
{
    constructor(addons)
    {
        this.addons = addons ?? {};

        
        Object.values(this.addons).map(( addon, key )=>{
            let type = Object.keys(this.addons)[key];

            this.addons[type] = this[type](addon);
            if(this.addons[type] === false){
                delete this.addons[type];
            }
        })

        return this.addons;
    }
    email_marketing(addon)
    {
        if(addon.limit <= 0){
            return false;
        }
        return addon;
    }
}

const StoreCart = storeCart();
export {StoreCart, ItemCart, CartParserAddons};